import React, { useMemo } from 'react';
import { attributesForContactInfo, contactOptionsForContactInfo } from '@repo/utils/models/Contact';
import { ContactInfo } from '@repo/utils/types';
import { PhoneIcon, SpeechBubbleIcon } from '@repo/icons';
import { DropdownMenu } from '@repo/components/menus';

import styles from './PhoneSource.module.scss';

export default function PhoneSource({ source }: { source: ContactInfo }) {
  const { displayValue } = attributesForContactInfo(source, true);
  const contactOptions = useMemo(
    () =>
      contactOptionsForContactInfo(source).map((contactInfo) => {
        const { href } = attributesForContactInfo(contactInfo, true);
        return {
          title: contactInfo.type === 'phone' ? 'Call' : 'Text',
          action: () => (window.location.href = href),
          icon: contactInfo.type === 'phone' ? PhoneIcon : SpeechBubbleIcon,
          className: styles.phoneContactOption,
        };
      }),
    [],
  );

  return (
    <DropdownMenu
      options={contactOptions}
      menuClassName={styles.phoneContactOptionsMenu}
      triggerClassName={styles.phoneContactOptionsTrigger}
      triggerProps={{ children: displayValue }}
      align="start"
    />
  );
}
